import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Isupport } from "../../../Pages/Setting/ISetting";

export const AddSupportSlice = createSlice({
  name: "AddSupportSlice",
  initialState: {} as IReduxState<Isupport>,
  reducers: {
    addSupport: (state, _: PayloadAction<Isupport>) => {
      state.isLoading = true;
    },
    successaddSupport: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddSupport: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSupportResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSupport,
  failureaddSupport,
  successaddSupport,
  clearAddSupportResponse,
} = AddSupportSlice.actions;

export default AddSupportSlice.reducer;
